import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Admin from "@system/config/admin";
import { AgGridReact } from 'ag-grid-react';
import { useAdminCommonStore } from 'src/hooks/admin/adminCommon';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/helper/Helper';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

export function AdminBomList() {
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { fetch_bom_Management_list }] = useAdminCommonStore();
    const [{ filter_list }] = useObjCommonFilterStore();
    const [rowData, setRowData] = useState([]);
    const gridRef = useRef();
    const [bomManagementList, setBomManagementList] = useState([]);
    const [{ }, { system_alert_indicator, clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
    const [gridColumnApi, setGridColumnApi] = useState(null);

    const loadUserId = (e) => (
        <a href={`${Admin.getBomManagerDetailsURL()}?bomId=${e?.data?.BomID}`} className='' target="_blank" rel="noreferrer">
            {e.value}
        </a>
    );

    const [columnDefs] = useState([
        {
            field: 'BomID',
            minWidth: 150,
            headerName: 'BOM ID',
            headerTooltip: 'BOM ID',
            sortable: true,
            cellRenderer: loadUserId,
        },
        {
            field: 'BOMName',
            headerName: 'BOM Name',
            headerTooltip: 'BOM Name',
            sortable: true,
        },
        {
            field: 'CreatedDate',
            headerName: 'Created Date',
            headerTooltip: 'Created Date',
            sortable: true,
            filter: 'agDateColumnFilter',
            filterParams: {
                suppressAndOrCondition: true,
                comparator: Helper.calendarAgGridComparator,
            }
        },
        {
            field: 'LastUpdated',
            minWidth: 130,
            headerName: 'Last Updated',
            headerTooltip: 'Last Updated',
            sortable: true,
            filter: 'agDateColumnFilter',
            filterParams: {
                suppressAndOrCondition: true,
                comparator: Helper.calendarAgGridComparator,
            }
        }
    ]);

    const defaultColDef = useMemo(() => ({
        flex: 1,
        sortable: true,
        filter: true,
        enableRowGroup: true,
        enableValue: true,
        resizable: true
    }), []);

    useEffect(() => {
        async function fetchHere() {
            await fetchAPICall()
        }
        fetchHere();
    }, [filter_list]);

    const fetchAPICall = async () => {
        __set('BOM_MANAGEMENT_API_CALL');
        if (Object.entries(filter_list).length > 0) {
            const params = {
                bomId: filter_list?.bomId?.searchKeyword || ''
            };
            const response = await fetch_bom_Management_list(params);
            if (response?.ErrorCode === '403') {
                system_alert_indicator({
                    name: "accessDenied",
                    message: response?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
            }
            if (response?.ErrorCode === 422) {
                system_alert_indicator({
                    name: 'bomManager',
                    message: "Please enter the complete BOM ID.",
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false,
                })
                setRowData([])
            } else {
                setBomManagementList(response);
            }

        } else {
            setRowData([])
            clear_all_system_alert({})

        }
        __remove('BOM_MANAGEMENT_API_CALL');
    };

    useEffect(() => {
        if (bomManagementList) {
            const bomData = {
                BomID: bomManagementList.id,
                BOMName: bomManagementList.name,
                CreatedDate: bomManagementList.createdDate ? Helper.convertDateFormatToMMDDYYYY(bomManagementList.createdDate) : "",
                LastUpdated: bomManagementList.updatedDate ? Helper.convertDateFormatToMMDDYYYY(bomManagementList.updatedDate) : "",
            }
            setRowData(bomData);
        }
    }, [bomManagementList]);


    const onExportAll = async () => {
        const allColumnState = gridColumnApi.getColumnState();
        const customColumns = allColumnState
            .filter((column) => column.hide !== true && column.colId != '0')
            .map((column) => column.colId);
        let params = { fileName: `bom_list.xlsx`, sheetName: "bom_list", columnKeys: customColumns };
        gridRef.current.api.exportDataAsExcel(params);
    }
    const onGridReady = (params) => {
        setGridColumnApi(params.columnApi);
    };
    return (
        <>
            <div className='bg-black p-2'>
                <div className='d-flex align-items-center justify-content-between'>
                    <span></span>
                    <div className='d-flex align-items-center'>
                        {Object.entries(rowData).length > 0 && rowData.BomID && <span id="emailFilter" className="dropdown me-2">
                            <a href={void (0)} onClick={onExportAll} className='text-white'>
                                <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
                            </a>
                        </span>
                        }
                    </div>
                </div>
            </div>

            {__check(['BOM_MANAGEMENT_API_CALL', 'COMMON_API_CALL']).render}
            {!__check(['BOM_MANAGEMENT_API_CALL', 'COMMON_API_CALL']).status &&
                <>
                    {Object.entries(rowData).length > 0 && rowData.BomID ?
                        <div className="ag-theme-alpine ag-grd-hg mb-5">
                            <AgGridReact
                                ref={gridRef}
                                rowData={[rowData]}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                rowSelection={'multiple'}
                                suppressRowClickSelection={true}
                                onGridReady={onGridReady}
                                autoGroupColumnDef={{
                                    headerName: 'Group',
                                    minWidth: 220,
                                }}
                            >
                            </AgGridReact>
                        </div> :
                        <>
                            {(Object.entries(filter_list).length > 0) ?
                                <div className='container mt-5'>
                                    <NoResultContent message={`Sorry! We can't find any results based on your selection.`} isDisplay={false} />
                                </div>
                                : <div className='d-block pt-5 pb-5 mt-5 mb-5 minh150'> </div>
                            }
                        </>
                    }
                </>
            }
        </>
    );
}
